import React, { useMemo } from "react";
import SectionCard from "./SectionCard";
import { ColorInput } from "./Fields";

export default function ColorsSection({
  form,
  onChangeColor,
  onApplyColors,
  onSaveColors,
  savingColors,
  dark,
  toggleDark,
}) {
  const ColorPreview = useMemo(() => {
    return (
      <div className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <div
          className="rounded-3xl p-5 text-white"
          style={{
            background: `linear-gradient(90deg, ${form.primary_color}, ${form.primary_color2})`,
          }}
        >
          <div className="text-sm opacity-90">En-tête du site</div>
          <div className="mt-1 text-2xl font-bold">
            Aperçu des tonalités
          </div>
        </div>

        <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950">
            <div className="text-sm text-slate-500 dark:text-slate-400">
              Bouton principal
            </div>

            <button
              type="button"
              className="mt-3 inline-flex items-center rounded-2xl px-4 py-2 font-bold text-white shadow"
              style={{
                background: `linear-gradient(90deg, ${form.button_primary_color}, ${form.button_primary_color2})`,
              }}
            >
              Action
            </button>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950">
            <div className="text-sm text-slate-500 dark:text-slate-400">
              Lien
            </div>

            <a
              href="#!"
              className="mt-3 inline-block font-bold underline underline-offset-4"
              style={{ color: form.primary_color }}
            >
              Lien d’exemple
            </a>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950">
            <div className="text-sm text-slate-500 dark:text-slate-400">
              Badge
            </div>

            <div
              className="mt-3 inline-flex items-center rounded-full px-3 py-1 text-sm font-bold"
              style={{
                backgroundColor: `${form.primary_color}22`,
                color: form.primary_color,
              }}
            >
              Information
            </div>
          </div>
        </div>
      </div>
    );
  }, [
    form.primary_color,
    form.primary_color2,
    form.button_primary_color,
    form.button_primary_color2,
  ]);

  return (
    <SectionCard
      title="Tonalités du site"
      description="Couleurs principales utilisées sur le site public."
      actions={
        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={onApplyColors}
            className="inline-flex items-center rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            Appliquer l’aperçu
          </button>

          <button
            type="button"
            onClick={onSaveColors}
            disabled={savingColors}
            className="inline-flex items-center rounded-2xl bg-sky-600 px-4 py-2.5 text-sm font-bold text-white transition hover:bg-sky-700 disabled:opacity-60"
          >
            {savingColors ? "Enregistrement..." : "Enregistrer"}
          </button>
        </div>
      }
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <ColorInput
          label="Dégradé principal — début"
          name="primary_color"
          value={form.primary_color}
          onChange={onChangeColor("primary_color")}
          hint="Couleur principale du site."
        />

        <ColorInput
          label="Dégradé principal — fin"
          name="primary_color2"
          value={form.primary_color2}
          onChange={onChangeColor("primary_color2")}
          hint="Deuxième couleur du dégradé."
        />

        <ColorInput
          label="Bouton principal — début"
          name="button_primary_color"
          value={form.button_primary_color}
          onChange={onChangeColor("button_primary_color")}
        />

        <ColorInput
          label="Bouton principal — fin"
          name="button_primary_color2"
          value={form.button_primary_color2}
          onChange={onChangeColor("button_primary_color2")}
        />
      </div>

      <label className="mt-5 flex items-center justify-between rounded-3xl border border-slate-200 bg-slate-50 px-4 py-4 dark:border-slate-800 dark:bg-slate-950">
        <div>
          <div className="text-sm text-slate-500 dark:text-slate-400">
            Mode d’aperçu
          </div>

          <div className="font-bold text-slate-950 dark:text-slate-50">
            Aperçu {dark ? "sombre" : "clair"}
          </div>
        </div>

        <button
          type="button"
          onClick={toggleDark}
          className="relative inline-flex h-8 w-14 items-center rounded-full bg-slate-300 dark:bg-slate-700"
          title="Basculer clair/sombre"
        >
          <span
            className={`inline-block h-6 w-6 transform rounded-full bg-sky-600 transition ${
              dark ? "translate-x-7" : "translate-x-1"
            }`}
          />
        </button>
      </label>

      <div className="mt-6">{ColorPreview}</div>
    </SectionCard>
  );
}